import { Button, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { ErrorBox, FlexBox } from 'components/Box'
import { selectColor, StatusChip } from 'components/Chips/StatusChip'
import { BoxForm, TextField } from 'components/Form'
import Tooltip from 'components/Tooltip'
import { Dialog } from 'features/globalSetup/pages/GoogleAdManagerConnectionPage/sections/SetupPrebidStackSection/components/Dialog'
import { GamStatus } from 'features/globalSetup/types/gamStatus'
import { DATE_FORMAT, formatDate } from 'utils/date'
import { useAccessibility } from '../hooks/useAccessibility'
import { CommonProps } from '../types'
import { Schema } from './schema'

export const Form = ({
  formId,
  gamSetupOrder,
  isDialogOpen,
  setIsDialogOpen,
}: CommonProps): JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.setupPrebidStack',
  })
  const { control } = useFormContext<Schema>()
  const { isActionDisabled, isSaveButtonDisabled, isSaveButtonVisible } = useAccessibility<Schema>({
    gamSetupOrder,
  })

  return (
    <BoxForm>
      <FlexBox
        axis='x'
        gap={1}
      >
        <Typography>{t('form.native.header')}</Typography>
        {gamSetupOrder && (
          <Tooltip
            content={
              gamSetupOrder.status === 'completed'
                ? t('form.statusTooltip', {
                    updatedAt: formatDate(gamSetupOrder.updatedAt, DATE_FORMAT.WITH_TIME),
                  })
                : ''
            }
          >
            <StatusChip
              chipColors={theme => selectColor<GamStatus>(gamSetupOrder.status, theme)}
              status={gamSetupOrder.status}
            />
          </Tooltip>
        )}
      </FlexBox>

      <TextField
        control={control}
        disabled={isActionDisabled}
        label={t('form.native.nativeTemplateId.label')}
        name='nativeTemplateId'
      />

      {gamSetupOrder &&
        gamSetupOrder.status === 'failed' &&
        gamSetupOrder.errorMessage !== undefined && (
          <ErrorBox errorMessage={gamSetupOrder.errorMessage} />
        )}

      {isSaveButtonVisible && (
        <Button
          disabled={isSaveButtonDisabled}
          onClick={(): void => setIsDialogOpen(true)}
          sx={{ width: 'fit-content' }}
          variant='contained'
        >
          {t('form.start.label')}
        </Button>
      )}

      <Dialog<Schema>
        formId={formId}
        gamSetupOrder={gamSetupOrder}
        isOpen={isDialogOpen}
        setOpen={setIsDialogOpen}
      />
    </BoxForm>
  )
}
